<template>
  <div class="comContent">
    <div class="shop-info-root tab-content new-cls" style="height: 100%;">
      <el-form :disabled="true">
        <el-row>
          <div class="form form-top">
            <div class="row" v-if="formIn.remark && formIn.auditStatus =='NOT_PASS'">
              <div class="tip">驳回原因</div>
              <div class="value input  big-w">
                <el-input autosize placeholder="" v-model="formIn.remark" :disabled="true" type="textarea" />
              </div>
            </div>
          </div>
        </el-row>


        <el-row>
          <el-col :span="24">
            <div class="left_topic mb20">基本信息</div>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺名称" label-width="120px">
              <el-input size="small" placeholder="" v-model="formIn.shopName" maxlength="20" />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="运营负责人" label-width="120px">
              <el-input size="small" placeholder="" v-model="formIn.shopHeadOperations" maxlength="15" />
            </el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" label-width="120px">
              <el-input size="small" placeholder="" v-model="formIn.shopContactNumber" maxlength="15" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺Logo" label-width="120px">
              <div class="value fill">
                <div class="public-pic-layout">
                  <div v-if="formIn.shopLogo" class="item">
                    <el-image :ref="`myImgLogo`" :src="formIn.shopLogo" fit="cover" class="icon" :initial-index="0"
                      :preview-src-list="[formIn.shopLogo]" />
                    <div class="preview">
                      <el-image :src="SeeIcon" class="btn-icon" @click="handlePreview(`myImgLogo`, false)" />
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="销售政策与条款" label-width="120px">
              <el-input type="textarea" v-model="formIn.salesPolicy" show-word-limit autosize resize="none" :rows="4"
                placeholder=" "></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="配送政策" label-width="120px">
              <el-input type="textarea" v-model="formIn.sendRule" show-word-limit autosize resize="none" :rows="4"
                placeholder=" "></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业介绍" label-width="120px">
              <el-input type="textarea" v-model="formIn.shopDesc" show-word-limit autosize resize="none" :rows="6"
                placeholder=" "></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="店铺公告" label-width="120px">
              <el-input type="textarea" v-model="formIn.shopAnnouncement" show-word-limit autosize resize="none" :rows="6"
                placeholder=" "></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <div class="left_topic mb20">售后收货信息</div>
          </el-col>

          <el-col :span="12">
            <el-form-item label="收货人" label-width="120px">
              <el-input size="small" placeholder="" v-model="formIn.queryAfterSalesSettingsVO.consignee" maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收货地址" label-width="120px">
              <el-input size="small" placeholder="" v-model="formIn.queryAfterSalesSettingsVO.consigneeAddress"
                maxlength="20" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="left_topic mb20">退换货流程</div>
          </el-col>

          <el-col :span="12">
            <el-form-item label="文字说明" label-width="120px">
              <el-input type="textarea" maxlength="2000" show-word-limit resize="none" :rows="6" placeholder="" autosize
                v-model="formIn.queryAfterSalesSettingsVO.changingRefundingInstructions"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="left_topic mb20">客户开户方式</div>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="accountOpeningInstructions" label="附加说明" label-width="120px">
              <el-input type="textarea" v-model="formIn.queryShopOpenAccountSettingsVO.accountOpeningInstructions"
                show-word-limit autosize resize="none" :rows="6" placeholder=" "></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div class="bottom-btn">
        <el-button type="plain" @click="goBack" size="small">返回</el-button>
        <el-button type="plain" class="fix-four" @click="doUpdateInfo('REJECT')" v-if="pageType == 'audit'"
          size="small">驳回</el-button>
        <el-button type="primary" class="fix-four" @click="doUpdateInfo('PASS')" v-if="pageType == 'audit'"
          size="small">审核通过</el-button>
      </div>
    </div>

    <el-dialog title="驳回原因" :visible.sync="visible" :lock-scroll="true" width="600px" :before-close="handleClose">
      <el-form ref="formDailog" :inline="true" style="text-align: left" label-width="140px">
        <el-row class="reject-c">
          <el-input v-model="remark" type="textarea" clearable size="small" style="width:100%" placeholder="请填写200字以内驳回原因"
            maxlength="200" />
        </el-row>
      </el-form>
      <div class="btnBox">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button type="primary" size="small" @click="rejectSub">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>


const IConst_Small = require("@/assets/public/icon-small.png");
const IConst_See_Icon = require("@/assets/zz/see-icon.png");
const IConst_Del_Icon = require("@/assets/zz/del-icon.png");
const IConst_Add_Icon = require("@/assets/zz/add-icon.png");

import { getShopInformation, auditShopInformation } from "@/api/shopmange";

import _ from "lodash";

export default {
  components: {},
  data () {
    return {
      SeeIcon: IConst_See_Icon,
      DelIcon: IConst_Del_Icon,
      AddIcon: IConst_Add_Icon,

      imgType: "",
      IConst_Max_Pic_Count: 5,
      imageUrlList: [],

      shopDetail: null,

      formIn: {
        remark: '',//驳回原因
        auditStatus: "", //状态码
        shopId: "",
        shopName: "", //店铺名称
        shopLogo: "", //店铺logo
        shopServiceTel: "", // 客户电话
        shopCompanyName: "", //店铺公司名称
        shopCompanyAddress: "", //店铺公司地址
        shopHeadOperations: "", //店铺运营负责人
        shopContactNumber: "", //联系电话
        shopErpCode: "", //店铺erp编码
        accountOpeningInstructions: "", //开户说明
        queryAfterSalesSettingsVO: {},
        queryShopOpenAccountSettingsVO: {},
      },
      visible: false,
      shopId: null,
      remark: '',
      pageType: '',
    };
  },
  created () {

  },
  computed: {
    showSave () {
      return !this.formIn.auditStatus || this.formIn.auditStatus === "PRESERVE";
    },
  },
  mounted () {
    if (this.$route.query.shopId) {
      this.shopId = this.$route.query.shopId;
      this.doLoadInfo();
    }

    if (this.$route.query.type) {
      this.pageType = this.$route.query.type;
    }
  },
  methods: {
    doUpdateInfo (type) {
      if (type == 'REJECT') {
        this.visible = true;
      }
      if (type == 'PASS') {
        this.$confirm(`确定要审核通过吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.passSub();
          })
          .catch(() => { });
      }
    },
    handleClose () {
      this.visible = false;
    },
    passSub () {
      let params = {};
      params.id = this.shopId;
      params.auditStatus = 'PASS';
      auditShopInformation(params).then((res) => {
        if (res) {
          this.$message.success('操作成功！')
          this.handleClose();
          this.$router.back(-1);
        }
      }).catch((err) => { })
    },
    rejectSub () {
      if (!this.remark) {
        this.$message.error('请填写驳回原因！')
        return
      }
      let params = {};
      params.id = this.shopId;
      params.remark = this.remark;
      params.auditStatus = 'NOT_PASS';
      auditShopInformation(params).then((res) => {
        if (res) {
          this.$message.success('操作成功！')
          this.handleClose();
          this.remark = "";
          this.$router.back(-1)
        }
      }).catch((err) => { })
    },

    doLoadInfo () {
      let params = {};
      params.id = this.shopId;
      getShopInformation(params).then((data) => {
        if (data) {
          console.log(data, 'data')
          this.shopDetail = data;
          this.formIn = data;
          console.log(this.formIn, 'formIn')
        }
      });
    },

    handlePreview (refName) {
      if (this.$refs[refName]) {
        if (this.$refs[refName] instanceof Array) {
          this.$refs[refName][0].showViewer = true;
        } else {
          this.$refs[refName].showViewer = true;
        }
      }
    },
    handleDeleteImage (tag) {
      if (tag === "logo") {
        this.formIn.shopLogo = "";
      }
    },
    goBack () {
      this.$router.back(-1)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "style/index.scss";

.btnBox {
  margin-top: 20px;
}
</style>
